import 'izitoast/dist/css/iziToast.min.css'
import Vue from 'vue'

const toast = {
    error: (message, title = 'Error: ') => {
        return Vue.notify({
            group: 'notifications',
            title: title,
            text: message,
            type: 'error',
            duration: 5000
        })
    },
    success: (message, title = 'Success: ') => {
        return Vue.notify({
            group: 'notifications',
            title: title,
            text: message,
            type: 'success',
            duration: 5000
        })
    },
    event: (event) => {
        return Vue.notify({
            group: 'notifications',
            data: event,
            type: 'event',
            duration: 5000
        })
    },
    snapshot: (event) => {
        return Vue.notify({
            group: 'notifications',
            data: event,
            type: 'snapshot',
            duration: 5000
        })
    },
    deviceCommandState: (message, title = 'Success: ', data) => {
        return Vue.notify({
            group: 'notifications',
            title: title,
            text: message,
            data: data,
            type: 'deviceCommandState',
            duration: 15000
        })
    },
}

export default toast
